/*
 *
 * UrlTokenizationFields
 *
 * @version 1.0.0
 * @author Davide Polci
 * @since 13-Nov-2025
 */

import React from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import PortalTextInput from '@nexidigital/portaltextinput'
import { getFeatureParamsValue } from 'Utility/subscriptionMethods'
import { messages } from './languageModule'
import './UrlTokenizationFields.scss'

const UrlTokenizationFields = ({ formik, active, vas }) => {
  const intl = useIntl()
  const baseUrlValue = getFeatureParamsValue(vas, 'NetworkTokenization', 'TokenizationByCardSchemeBaseUrl')

  return (
    <>
      <div className='serviceConfig_3ds_container'>
        {baseUrlValue ? (
          <PortalTextInput
            ariaLabelIcon={intl.formatMessage(messages.warningAriaLabel)}
            ariaLabelInput={`${intl.formatMessage(messages.notificationUrl)}`}
            id='notificationUrl'
            disabled={!active}
            maxLength={255}
            label={`${intl.formatMessage(messages.notificationUrl)}`}
            placeholderBlank
            labelIcon='info'
            labelTooltip={intl.formatMessage(messages.notificationUrlTooltip)}
            error={formik?.errors?.subscriptionParams?.TokenizationByCardSchemeLifecycleNotificationUrl && formik?.touched?.subscriptionParams?.TokenizationByCardSchemeLifecycleNotificationUrl}
            errorText={formik?.errors?.subscriptionParams?.TokenizationByCardSchemeLifecycleNotificationUrl}
            onChange={(e) => formik.setFieldValue('subscriptionParams.TokenizationByCardSchemeLifecycleNotificationUrl', e.target.value)}
            onBlur={() => formik.setFieldTouched('subscriptionParams.TokenizationByCardSchemeLifecycleNotificationUrl', true)}
            onFocus={() => formik.setFieldTouched('subscriptionParams.TokenizationByCardSchemeLifecycleNotificationUrl', false)}
          />
        ) : (
          <div>
            <PortalTextInput
              ariaLabelIcon={intl.formatMessage(messages.warningAriaLabel)}
              ariaLabelInput={`${intl.formatMessage(messages.baseUrl)}`}
              id='baseUrl'
              label={`${intl.formatMessage(messages.baseUrl)}*`}
              maxLength={255}
              placeholderBlank
              disabled={!active}
              labelIcon={'info'}
              labelTooltip={intl.formatMessage(messages.baseUrlTooltip)}
              error={formik?.errors?.subscriptionParams?.TokenizationByCardSchemeBaseUrl && formik?.touched?.subscriptionParams?.TokenizationByCardSchemeBaseUrl}
              errorText={formik?.errors?.subscriptionParams?.TokenizationByCardSchemeBaseUrl}
              onChange={(e) => formik.setFieldValue('subscriptionParams.TokenizationByCardSchemeBaseUrl', e.target.value)}
              onBlur={() => formik.setFieldTouched('subscriptionParams.TokenizationByCardSchemeBaseUrl', true)}
            />

            <PortalTextInput
              ariaLabelIcon={intl.formatMessage(messages.warningAriaLabel)}
              ariaLabelInput={`${intl.formatMessage(messages.confirmBaseUrl)}`}
              id='confirmBaseUrl'
              label={`${intl.formatMessage(messages.confirmBaseUrl)}*`}
              placeholderBlank
              maxLength={255}
              disabled={!formik.values.subscriptionParams?.TokenizationByCardSchemeBaseUrl || formik?.errors?.subscriptionParams?.TokenizationByCardSchemeBaseUrl}
              labelIcon={'info'}
              labelTooltip={intl.formatMessage(messages.confirmBaseUrlTooltip)}
              error={formik?.errors?.subscriptionParams?.ConfirmTokenizationByCardSchemeBaseUrl && formik?.touched?.subscriptionParams?.ConfirmTokenizationByCardSchemeBaseUrl}
              errorText={formik?.errors?.subscriptionParams?.ConfirmTokenizationByCardSchemeBaseUrl}
              onChange={(e) => formik.setFieldValue('subscriptionParams.ConfirmTokenizationByCardSchemeBaseUrl', e.target.value)}
              onBlur={() => formik.setFieldTouched('subscriptionParams.ConfirmTokenizationByCardSchemeBaseUrl', true)}
            />
          </div>
        )}
      </div>
    </>
  )
}

UrlTokenizationFields.propTypes = {
  active: PropTypes.bool,
  vas: PropTypes.object.isRequired,
  formik: PropTypes.object.isRequired,
}

UrlTokenizationFields.defaultProps = {
  active: false,
  vas: {},
}

export default UrlTokenizationFields
